import { PATH_SETTINGS } from 'domains/userSettings/Routes';
import { createRouteConfig } from 'modules/router/utils/createRouteConfig';

export const PLATFORM_SWAGGER_PATH = `${PATH_SETTINGS}w3swagger/`;

export const platformSwaggerRoutesConfig = createRouteConfig(
  {
    platformSwagger: {
      path: PLATFORM_SWAGGER_PATH,
      generatePath: () => PLATFORM_SWAGGER_PATH,
      breadcrumbs: 'platform-swagger.breadcrumbs',
    },
  },
  PLATFORM_SWAGGER_PATH,
);
